import { Dispatch, SetStateAction } from "react"

export async function copyUrlToClipboard(setTooltipOpen: Dispatch<SetStateAction<boolean>>) {
  const currentUrl = `${window.location.origin}${window.location.pathname}`

  navigator.clipboard.writeText(currentUrl).then(() => {
    setTooltipOpen(true)
    setTimeout(() => setTooltipOpen(false), 1500)
  })
}

export async function shareUrlNavigator(
  setTooltipOpen: Dispatch<SetStateAction<boolean>>,
  text?: string,
) {
  const currentUrl = `${window.location.origin}${window.location.pathname}`

  if (navigator.share) {
    try {
      await navigator.share({
        title: text || "",
        url: currentUrl,
      })
    } catch (error) {
      console.error("Sharing failed:", error)
    }
  } else {
    navigator.clipboard.writeText(currentUrl).then(() => {
      setTooltipOpen(true)
      setTimeout(() => setTooltipOpen(false), 5000)
    })
  }
}

export async function copyColorToClipboard(
  colorCode: string,
  setTooltipOpen: Dispatch<SetStateAction<string | boolean>>,
) {
  const currentUrl = `${window.location.origin}${window.location.pathname}?colorCode=${colorCode}`

  navigator.clipboard.writeText(currentUrl).then(() => {
    setTooltipOpen(colorCode)
    setTimeout(() => setTooltipOpen(false), 1500)
  })
}

export async function shareColorNavigator(
  colorCode: string,
  setTooltipOpen: Dispatch<SetStateAction<string | boolean>>,
  text?: string,
) {
  const currentUrl = `${window.location.origin}${window.location.pathname}?colorCode=${colorCode}`

  if (navigator.share) {
    try {
      await navigator.share({
        title: text || "",
        url: currentUrl,
      })
    } catch (error) {
      console.error("Sharing failed:", error)
    }
  } else {
    navigator.clipboard.writeText(currentUrl).then(() => {
      setTooltipOpen(colorCode)
      setTimeout(() => setTooltipOpen(false), 5000)
    })
  }
}
